import React, { useEffect, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import * as Moment from "moment";
import ChatHeader from "../../pages/chat/header";
import { Outlet } from "react-router-dom";
import ChatContact from "../../pages/chat/contact";
import { useDispatch, useSelector } from "react-redux";
import { initializeSocket, socketActions } from "../../store/socket/slice";
import { listStaffOnline, readStaff } from "../../store/staff/thunkAction";
import { tokenAction } from "../../store/token/slice";
import { createSocketToken } from "../../store/token/thunkAction";
import { getProfileAllowed } from "../../store/profile/thunkAction";
import { listGroupIdByUser } from "../../store/group/thunkAction";
import Popup from "../../components/core/popup";
import { useTranslation } from "react-i18next";
import { reportStaff } from "../../store/session/thunkAction";

const ChatLayout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tokenManage = useSelector((state) => state.tokenManage);
  const staffManage = useSelector((state) => state.staffManage);
  const socketManage = useSelector((state) => state.socketManage);
  const [isOpenPopupSocket, setIsOpenPopupSocket] = useState(false);

  const staff = _.get(staffManage, "staff", {});
  const hasToken = _.get(tokenManage, "hasToken");
  const socketToken = _.get(tokenManage, "socketToken");
  const isConnected = _.get(socketManage, "isConnected");

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(tokenAction.checkToken());
    }, 1000);

    if (hasToken) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [hasToken, dispatch]);

  useEffect(() => {
    if (staff._id && !socketToken) {
      dispatch(
        createSocketToken({
          staffId: staff._id,
        })
      );
    }
  }, [dispatch, staff._id, socketToken]);

  useEffect(() => {
    if (socketToken) {
      dispatch(socketActions.setAccountId(staff.accountId));
      const cleanup = dispatch(initializeSocket(socketToken));
      return () => {
        cleanup();
      };
    }
  }, [dispatch, socketToken, staff.accountId]);

  useEffect(() => {
    setIsOpenPopupSocket(!isConnected);
  }, [isConnected]);

  useEffect(() => {
    if (hasToken) {
      dispatch(readStaff());
      dispatch(getProfileAllowed());
      dispatch(listGroupIdByUser());
      dispatch(reportStaff({
        startAt: Moment().startOf("day").valueOf(),
        endAt: Moment().endOf("day").valueOf(),
      }));
      dispatch(listStaffOnline());
    }
  }, [dispatch, hasToken]);

  const closePopupSocket = () => {
    setIsOpenPopupSocket(false);
  };

  return (
    <div className="section-chat">
      <ChatHeader />
      <div className="chat-body">
        <div className="row g-0 h-100">
          <ChatContact />
          <div className="col-md-9">
            <Outlet />
          </div>
        </div>
      </div>
      <Popup
        config={{
          isOpen: isOpenPopupSocket,
          onClose: closePopupSocket,
          isBackground: true,
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("agent.contact.socket_error")}</h5>
          </div>
          <p>{t("agent.contact.socket_error_desc")}</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            {t("agent.contact.reload")}
          </button>
        </div>
      </Popup>
    </div>
  );
};

export default ChatLayout;
